<template>
    <canvas ref="chart" width="100" height="100" />
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { Chart, type TooltipItem } from "./chart";

const chart = ref<HTMLCanvasElement | null>(null);
const parameters: any = {
    type: "line",
    data: {
        labels: [
            "20-29",
            "30-39",
            "40-49",
            "50-59",
            "60-69",
            "70-79",
            "80-89",
            "90-99",
        ],
        datasets: [
            {
                label: "Primary Male Hormone Levels",
                data: [705, 610, 499, 413, 359, 310, 278, 214],
                backgroundColor: "rgba(232, 37, 53, 0.7)",
                borderColor: "rgba(232, 37, 53, 1)",
                borderWidth: 1,
                fill: true,
            },
        ],
    },
    options: {
        scales: {
            x: {
                ticks: {
                    color: "#ffffff",
                },
                grid: {
                    borderColor: "rgba(255, 255, 255, 0.5)",
                    color: "rgba(255, 255, 255, 0.2)",
                },
            },
            y: {
                beginAtZero: true,
                grid: {
                    borderColor: "rgba(255, 255, 255, 0.5)",
                    color: "rgba(255, 255, 255, 0.2)",
                },
                ticks: {
                    color: "#ffffff",
                    callback: function (value: number | string) {
                        return `${value} ng/dL`;
                    },
                },
                title: {
                    color: "#ffffff",
                },
            },
        },
        plugins: {
            legend: {
                labels: {
                    color: "#ffffff",
                },
            },
            tooltip: {
                callbacks: {
                    label: function (context: TooltipItem<"line">) {
                        return `${context.formattedValue} ng/dL`;
                    },
                },
            },
        },
    },
};

onMounted(() => {
    if (chart.value) {
        new Chart(chart.value, parameters);
    }
});
</script>
